// removed by extract-text-webpack-plugin
module.exports = {"primaryBorder":"#f4f5f7","placeholder":"undefined","notificationSuccess":"undefined","notificationDeflection":"undefined","bluePrimary":"undefined","notificationError":"undefined","greenAction":"#15cd72","heading":"_2qCUQ _2RLxJ","header":"xGSiB _3t_1_","loader":"_3PCLX","button":"_kin- _3Vp3M","notification":"_2QhJ_","error":"_3gp2I _2QhJ_","success":"_1QvJH _2QhJ_","bodyContainer":"_3xh3Q","helpedContainer":"_1tVcl","helpedLogo":"_9jAkf","helpedText":"_1d_Ua"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/gatekeeperNotify/style.css
// module id = 904
// module chunks = 0